import { merge, MonoTypeOperatorFunction, Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

export function takeUntilFirst(
    ...sources: Observable<unknown>[]
): MonoTypeOperatorFunction<unknown> {
    return takeUntil(merge(...sources));
}
